import React, { useContext } from 'react';
import { Helmet } from 'react-helmet';

import Layout from '../components/Layout';
import { useAppState } from '../../index.js';
import HailPurdue from '../../images/hail-purdue-hero.jpg';

const NotFoundContent = (props) => {
  const { AppContext } = props;
  const { styleprops } = useContext(AppContext);

  return <div className="purdue-home-diagonal-hero has-none-background " style={{ ...styleprops }}>
    <div className="section has-padding-top-large has-padding-bottom-large">
      <div className="container">
        <div className="purdue-home-diagonal-hero__content">
          <p className="purdue-home-hero__subheader tagged-header tagged-header--gold purdue-home-diagonal-hero__subheader">Error</p>
          <h1 className="second-level-page-heading purdue-home-diagonal-hero__header">404 | Page Not Found</h1>
          <div className="purdue-home-diagonal-hero__subtext"><p>Hey there! So, you've landed on this page, and honestly, we're not sure how you ended up here. No biggie, though! If you're feeling a bit lost, hit that "back" button, or take the scenic route by using the site navigation to find what you were looking for. Got questions or just want to chat? Drop us a line using the link below, and we'll be right on it. Cheers for rolling with the web waves!</p></div>
          <div className="column is-narrow">
            <a className="purdue-home-button" href="/feedback/">Send us Feedback</a>
          </div>
        </div>
      </div>
    </div>
    <div className="image">
      <img src={HailPurdue} alt="Hail Purdue hero" />
    </div>
  </div>
}

const NotFound = (props) => {
  const { locations, currentUser, GET_USER } = useAppState();
  const { AppContext } = props;
  return (
    <>
      <Helmet>
        <title>404 - Page Not Found | Purdue Dining Menus</title>
        <meta name="description" content="The page you're looking for could not be found. Navigate back to Purdue Dining menus or use the site navigation." />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <Layout AppContext={AppContext} locations={locations} currentUser={currentUser} GET_USER={GET_USER} pageName="Not Found">
        <NotFoundContent AppContext={AppContext} />
      </Layout>
    </>
  );
}

export default NotFound;